import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useOtpAuth from '../hooks/useOtpAuth';
import logo from '../images/agribegri_1-removebg-preview.png';

const VerifyOtp = () => {
  const navigate = useNavigate();
  const {
    otp,
    setOtp,
    error,
    loading,
    resendDisabled,
    countdown,
    handleSendOtp,
    handleVerifyOtp,
    resetState
  } = useOtpAuth();

  useEffect(() => {
    // Check if user has mobile number stored
    const mobileNumber = localStorage.getItem('mobileNumber');
    if (!mobileNumber) {
      navigate('/login');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // On success handleVerifyOtp stores the user details and navigates onward itself
    // (back to the page they were heading to, else the dashboard).
    await handleVerifyOtp();
  };

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh', 
      background: 'linear-gradient(135deg, #e6f9ec 0%, #c8f2d8 100%)' 
    }}>
      <div style={{ 
        background: '#fff', 
        padding: '2.5rem 2rem', 
        borderRadius: '16px', 
        boxShadow: '0 4px 24px #0002', 
        minWidth: 320, 
        maxWidth: 380, 
        width: '100%', 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center' 
      }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 20 }}>
          <img 
            src={logo} 
            alt="AgriBegri Logo" 
            style={{ maxWidth: 190, width: '80%', height: 'auto', marginBottom: 10, display: 'block' }} 
          />
          <h2 style={{ fontWeight: 700, fontSize: 28, marginBottom: 8, color: '#18492b', letterSpacing: 1 }}>
            Verify OTP
          </h2>
          <p style={{ color: '#666', fontSize: 14, textAlign: 'center', marginTop: 8 }}>
            Enter the 4-digit OTP sent to your mobile number
          </p>
        </div>
        
        {error && (
          <div style={{ 
            color: '#d32f2f', 
            marginBottom: 12, 
            fontWeight: 500,
            padding: '8px 12px',
            background: '#ffebee',
            borderRadius: 6,
            width: '100%',
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <div style={{ marginBottom: 18 }}>
            <label style={{ fontWeight: 500, color: '#18492b', fontSize: 15 }}>OTP</label>
            <input 
              type="tel"
              value={otp}
              onChange={e => setOtp(e.target.value.replace(/\D/g, '').slice(0, 4))}
              placeholder="Enter 4-digit OTP"
              style={{ 
                width: '100%', 
                padding: '10px 12px', 
                borderRadius: 8, 
                border: '1px solid #b2dfc7', 
                marginTop: 6,
                fontSize: 15,
                background: '#f6fcf8',
                outline: 'none',
                transition: 'border 0.2s',
                boxSizing: 'border-box'
              }}
              disabled={loading}
            />
          </div>

          <button 
            type="submit" 
            style={{ 
              width: '100%', 
              background: 'linear-gradient(90deg, #38b87c 0%, #18492b 100%)', 
              color: '#fff', 
              padding: '12px 0', 
              border: 'none', 
              borderRadius: 8, 
              fontWeight: 600, 
              fontSize: 16,
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'all 0.2s',
              marginTop: 6,
              boxShadow: '0 2px 8px #38b87c22',
              opacity: loading ? 0.7 : 1
            }}
            disabled={loading}
          >
            {loading ? 'Please wait...' : 'Verify OTP'}
          </button>
        </form>

        <div style={{ marginTop: 18, textAlign: 'center', color: '#18492b', fontSize: 14 }}>
          <button
            onClick={handleSendOtp}
            disabled={resendDisabled || loading}
            style={{
              background: 'none',
              border: 'none',
              color: resendDisabled ? '#999' : '#38b87c',
              cursor: resendDisabled ? 'not-allowed' : 'pointer',
              padding: 0,
              fontSize: 14,
              fontWeight: 500
            }}
          >
            {resendDisabled ? `Resend OTP in ${countdown}s` : 'Resend OTP'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerifyOtp; 